"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REPORTS_LIST = exports.REPORTS_LIST = "reports/LIST";
var REPORTS_LIST_SUCCESS = exports.REPORTS_LIST_SUCCESS = "reports/LIST_SUCCESS";
var REPORTS_LIST_FAILED = exports.REPORTS_LIST_FAILED = "reports/LIST_FAILED";
var REPORTS_LIST_DISMISS_ERROR = exports.REPORTS_LIST_DISMISS_ERROR = "reports/LIST_DISMISS_ERROR";
var REPORTS_GET = exports.REPORTS_GET = "reports/GET";
var REPORTS_GET_SUCCESS = exports.REPORTS_GET_SUCCESS = "reports/GET_SUCCESS";
var REPORTS_GET_FAILED = exports.REPORTS_GET_FAILED = "reports/GET_FAILED";
var REPORTS_GET_DISMISS_ERROR = exports.REPORTS_GET_DISMISS_ERROR = "reports/GET_DISMISS_ERROR";
var REPORTS_REMOVE = exports.REPORTS_REMOVE = "reports/REMOVE";
var REPORTS_DEFINITIONS_LATEST = exports.REPORTS_DEFINITIONS_LATEST = "reports/DEFINITIONS_LATEST";
var REPORTS_DEFINITIONS_LATEST_SUCCESS = exports.REPORTS_DEFINITIONS_LATEST_SUCCESS = "reports/DEFINITIONS_LATEST_SUCCESS";
var REPORTS_DEFINITIONS_LATEST_FAILED = exports.REPORTS_DEFINITIONS_LATEST_FAILED = "reports/DEFINITIONS_LATEST_FAILED";
var REPORTS_DEFINITIONS_DISMISS_ERROR = exports.REPORTS_DEFINITIONS_DISMISS_ERROR = "reports/DEFINITIONS_DISMISS_ERROR";
var REPORTS_DEFINITION = exports.REPORTS_DEFINITION = "reports/DEFINITIONS";
var REPORTS_DEFINITION_SUCCESS = exports.REPORTS_DEFINITION_SUCCESS = "reports/DEFINITIONS_SUCCESS";
var REPORTS_DEFINITION_FAILED = exports.REPORTS_DEFINITION_FAILED = "reports/DEFINITIONS_FAILED";
var REPORTS_DEFINITION_DISMISS_ERROR = exports.REPORTS_DEFINITION_DISMISS_ERROR = "reports/DEFINITION_DISMISS_ERROR";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reports/constants.ts
 ** module id = 643
 ** module chunks = 0
 **/